import { z } from '@harvestiq/zod';
import { zDecimalRequired, zIsoDate } from '@harvestiq/zod';
import {
  CoverageTiers,
  InsureIQPolicyTypes,
  LrpCampaignPdfColumns,
} from '@harvestiq/constants';
import { lrpQuoteSchema } from '@harvestiq/usda-common';

export const lrpQuoteAndPdfResponseSchema = z.object({
  policyType: z.literal(InsureIQPolicyTypes.LRP),
  filename: z.string(),
  fileUrl: z.string(),
  salesEffectiveDate: zIsoDate(),
  targetWeight: zDecimalRequired().nullable(),
  numberOfHead: z.number().int().min(1),
  coverageTier: z.nativeEnum(CoverageTiers),
  quotes: z.record(z.string(), lrpQuoteSchema.array()),
  quoteColumns: z.array(z.nativeEnum(LrpCampaignPdfColumns)).optional(),
  isPre2026BeginningFarmerRancher: z.boolean().optional(),
  isVeteranFarmerRancher: z.boolean().optional(),
  beginningFarmerRancherCropYearCount: z.number().int().nullable().optional(),
});

export type LrpQuoteAndPdfResponse = z.infer<
  typeof lrpQuoteAndPdfResponseSchema
>;

export const lrpQuoteTemplateDataSchema = lrpQuoteAndPdfResponseSchema.extend({
  message: z.string().optional(),
  unsubscribeURL: z.string().url().optional(),
  campaignId: z.string().uuid().optional(),
});

export type LrpQuoteTemplateData = z.infer<typeof lrpQuoteTemplateDataSchema>;
